import { render } from "./ShareWithMe.vue?vue&type=template&id=468e7ecc"
import script from "./ShareWithMe.vue?vue&type=script&lang=js"
export * from "./ShareWithMe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__